export var defaultProps = {
    className: '',
    style: {},
    max: Number.MAX_SAFE_INTEGER,
    min: 1,
    isLock: false,
    readOnly: false,
    defaultValue: 1,
    prefixCls: '',
    step: 1,
    type: 'normal',
    disabled: false,
    onBeforeChange: function () { return true; },
};
